<template>
  <div>
    <v-row>
      <v-col cols="6">
        <div class="font-weight-normal text-h4 d-none d-sm-inline">
          Olá, {{authUser.NOME || authUser.NOMECOMPLETO}} <br>
          Seja bem vindo(a) ao sistema 
          <span class="text-h4 font-weight-bold black--text"> Gestao<span class="font-weight-bold texto-vermelho-escuro">WEB</span></span>
        </div>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="4" lg="2">
          <v-hover>
              <template v-slot:default="{ hover } ">
                  <v-card color="rgba(0,0,0,0.75)" outlined>
                      <v-img src="/images/pdv_balcao.jpg" alt="Mini carrinho de super-mercado com caixas dentro."></v-img>
                      <v-card-text>
                      <h2 class="text-h5 font-weight-bold white--text">PDV - Balcão</h2>
                      <p class="white--text">Realizar vendas, criar listas de compras,..</p>
                      </v-card-text>
                      <v-fade-transition>
                          <v-overlay
                          v-if="hover"
                          absolute
                          color="rgb(0,0,0)">
                            <v-btn color="rgba(183,28,28,0.75)" class="text-overline" :to="{name:'PDV'}">Acessar PDV Balcão</v-btn>
                          </v-overlay>
                      </v-fade-transition>
                  </v-card>
              </template>
          </v-hover>
      </v-col>      
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => {
    return {}
  },
  computed: {
    ...mapState('authModule',['authUser'])
  },
  methods: {
    redirectToPDV(){
      this.$router.push({name:'PDV'})
    }
  }
}
</script>

<style></style>
